module.exports = __webpack_public_path__ + "static/01-3-f9ee58fc8582211b54a7ade0f66cb9e7.jpg";